import React from 'react';
import {
  FiUserPlus,
  FiShield,
  FiPackage,
  FiUsers,
  FiUserCheck,
  FiCpu,
  FiMessageSquare,
  FiCalendar,
  FiClipboard,
  FiDatabase,
  FiSettings,
  FiGrid,
} from 'react-icons/fi';
import DashboardCardGrid from '../components/DashboardCardGrid';

export const HOME_CARD_DATA = [
  {
    title: 'Create User',
    description: 'Add new user with essential details.',
    path: '/create-user',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiUserPlus size={28} />,
    accent: '#0ea5e9',
  },
  {
    title: 'User Dashboard',
    description: "Browse every user and open their dashboard.",
    path: '/admin/users',
    roles: ['AdminController', 'Hr'],
    icon: <FiGrid size={28} />,
    accent: '#6366f1',
  },
  {
    title: 'Create Admin',
    description: 'Set up new administrative accounts.',
    path: '/create-admin',
    roles: ['Hr', 'AdminController'],
    icon: <FiShield size={28} />,
    accent: '#8b5cf6',
  },
  {
    title: 'Create Robot For User',
    description: 'Create and assign robot details for users.',
    path: '/robot-form',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiPackage size={28} />,
    accent: '#06b6d4',
  },
  {
    title: "User's List",
    description: 'View and manage all user details.',
    path: '/users-list',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiUsers size={28} />,
    accent: '#0d9488',
  },
  {
    title: "Admin User's",
    description: 'View and manage admin accounts.',
    path: '/admin-user',
    roles: ['Hr', 'ProjectManager'],
    icon: <FiUserCheck size={28} />,
    accent: '#6366f1',
  },
  {
    title: "User's Robot",
    description: 'View and manage user robot details.',
    path: '/user-robot',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiCpu size={28} />,
    accent: '#14b8a6',
  },
  {
    title: 'Robot Messages',
    description: 'View and manage robot messages.',
    path: '/RobotMsgList',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiMessageSquare size={28} />,
    accent: '#f59e0b',
  },
  {
    title: 'Robot Demo Booking',
    description: 'Manage demo booking availability.',
    path: '/Robot-Booking',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiCalendar size={28} />,
    accent: '#ec4899',
  },
  {
    title: 'Demo Booking Details',
    description: 'View and manage booking details.',
    path: '/Booking-details',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiClipboard size={28} />,
    accent: '#10b981',
  },
  {
    title: 'Update Metadata',
    description: 'Update robot metadata and permissions.',
    path: '/update-apppermession',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiDatabase size={28} />,
    accent: '#3b82f6',
  },
  {
    title: 'Cache Settings',
    description: 'Configure app cache and performance.',
    path: '/CacheSettings',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiSettings size={28} />,
    accent: '#64748b',
  }
];

export default function CardGridDashboard() {
  return (
    <DashboardCardGrid
      pageTitle="Admin Dashboard"
      pageSubtitle="Quick access to users, robots, bookings, and settings"
      cardData={HOME_CARD_DATA}
    />
  );
}
